import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Form, Spinner, Dropdown, Modal, Button } from "react-bootstrap";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { MoneyRecive, MoneySend, More, Trash, User } from 'iconsax-react';
import { useNavigate } from "react-router-dom";
import MyApiClient from "../../../../../api-client/MyApiClient";
import { useProfile } from "../../../../../hooks/useProfile";

import { conMotivo } from "../../../../components/Util/erroreServer";
import chiediConferma from "../../../../components/Util/chiediConferma";
import { segnalaMancanti } from "../../../../components/Util/campiMancanti";
import { CampiPeriodo, calendarioDelPeriodo, giornoItaliano, oggiISO } from "../../../../components/Util/periodoCalendario";
const LessonsCalendar = () => {
  const navigate = useNavigate();
  const { profile, loading: profileLoading } = useProfile();
  const isFatturazioneConfirmed = profile?.club?.invoiceDataSender?.status === 'CONFIRMED';
  const [lessons, setLessons] = useState([]);
  const [selectedLessonId, setSelectedLessonId] = useState("");
  const [coaches, setCoaches] = useState([]);
  const [selectedCoachName, setSelectedCoachName] = useState("");
  // Uno o più giorni (TASK #14, 29/10/2026): all'apertura oggi
  const [periodo, setPeriodo] = useState(() => ({ dal: oggiISO(), al: oggiISO() }));
  const [loadingLessons, setLoadingLessons] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const controlHeight = '32px';

  // Stati per azioni e modali (coerenti con lista acquisti)
  const [confirmPaymentShowed, setConfirmPaymentShowed] = useState(false);

  const [modalShowed, setModalShowed] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalText, setModalText] = useState('');

  const [loadingShowed, setLoadingShowed] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const optionsPayment = [
    { value: "CASH", label: "Contanti" },
    { value: "CARD", label: "Carta di credito" },
    { value: "BANK_TRANSFER", label: "Bonifico" }
  ];
  const [modalita_pagamento, setModalita_pagamento] = useState('');
  const [skip_generate_document, setSkipGenerateDocument] = useState(false);

  const [bookingPlayerModal, setBookingPlayerModal] = useState(false);
  const [pendingBookingSlot, setPendingBookingSlot] = useState(null);
  const [selectedBookingPlayer, setSelectedBookingPlayer] = useState(null);

  const loadBookingPlayerOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 3) return [];
    try {
      const tokenDetailsString = sessionStorage.getItem('userDetails');
      if (tokenDetailsString) {
        const tokenDetails = JSON.parse(tokenDetailsString);
        const token = tokenDetails.idToken;
        const apiClient = new MyApiClient();
        const playersData = await apiClient.getProfilesByFilters(token, 10000, inputValue, 'IDS_PLAY');
        if (playersData && !playersData.error) {
          return playersData.items.map(el => ({ value: el.userId, label: el.name }));
        }
      }
    } catch (e) {
      console.error(e);
    }
    return [];
  };

  const openBookingModal = (row) => {
    setPendingBookingSlot(row);
    setSelectedBookingPlayer(null);
    setBookingPlayerModal(true);
  };

  const confirmBooking = () => {
    // Dato mancante: si evidenzia il campo (regola «Dati mancanti»)
    if (!selectedBookingPlayer) {
      segnalaMancanti([{ campo: 'prenota-player', messaggio: 'Manca il player: cercalo e sceglilo dalla lista' }]);
      return;
    }
    if (!pendingBookingSlot) return;
    const row = pendingBookingSlot;
    const url = `/struttura/booking/userLessons?date=${encodeURIComponent(row.date)}&lessonId=${encodeURIComponent(row.lessonId)}&startTime=${encodeURIComponent(row.startTime)}&endTime=${encodeURIComponent(row.endTime)}${row.sportType ? `&sportType=${encodeURIComponent(row.sportType)}` : ''}&playerId=${encodeURIComponent(selectedBookingPlayer.value)}&playerName=${encodeURIComponent(selectedBookingPlayer.label)}`;
    navigate(url);
  };

  useEffect(() => {
    if (!profileLoading && profile && !isFatturazioneConfirmed && skip_generate_document !== true) {
      setSkipGenerateDocument(true);
    }
  }, [profileLoading, profile, isFatturazioneConfirmed, skip_generate_document]);
  const handleSelectChange = (selectedOption, name) => {
    if (name === 'modalita_pagamento') {
      setModalita_pagamento(selectedOption.value);
    } else if (name === 'skip_generate_document') {
      setSkipGenerateDocument(selectedOption.value);
    }
  };

  // Recupero token come nel calendar impianti
  const token = useMemo(() => {
    try {
      const s = sessionStorage.getItem("userDetails");
      if (s) {
        const obj = JSON.parse(s);
        return obj.idToken;
      }
    } catch (e) {}
    return null;
  }, []);

  useEffect(() => {
    const loadLessons = async () => {
      if (!token) return;
      setLoadingLessons(true);
      try {
        const api = new MyApiClient();
        const list = await api.getBookingLessons(token);
        // Le bozze non si prenotano; una lezione di gruppo e' una lezione per ogni maestro, con lo
        // stesso nome: il maestro accanto al nome le distingue nel filtro.
        const prenotabili = (list || []).filter(l => l.status !== 'DRAFT');
        const quanti = {};
        prenotabili.forEach(l => { const n = l.name || l.lessonName; quanti[n] = (quanti[n] || 0) + 1; });
        const opts = prenotabili.map(l => {
          const nome = l.name || l.lessonName;
          return {
            value: l.id || l.lessonId || l.uuid,
            label: quanti[nome] > 1 && l.coachName ? `${nome} · ${l.coachName}` : nome,
            sportType: l.sportType,
            coachName: l.coachName
          };
        }).sort((x, y) => String(x.label).localeCompare(String(y.label)));
        setLessons(opts);
        const coachSet = new Set((list || []).map(l => l.coachName).filter(Boolean));
        const coachOpts = Array.from(coachSet).sort((a,b) => a.localeCompare(b)).map(name => ({ value: name, label: name }));
        setCoaches(coachOpts);
      } catch (e) {
        console.error(e);
      } finally {
        setLoadingLessons(false);
      }
    };
    loadLessons();
  }, [token]);

  const fetchCalendar = async () => {
    if (!token || !periodo.dal) return;
    setLoading(true);
    try {
      const api = new MyApiClient();
      const res = await calendarioDelPeriodo(periodo.dal, periodo.al, (giorno) => api.getUserLessonsCalendar(token, giorno, selectedLessonId || null));
      setData(res);
    } catch (e) {
      console.error(e);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCalendar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodo, selectedLessonId, token]);

  const [selectedSlot, setSelectedSlot] = useState("");
  const slotOptions = useMemo(() => {
    const set = new Set();
    (data || []).forEach(item => {
      const lessonMatch = !selectedLessonId || String(item.lessonId) === String(selectedLessonId);
      const coachMatch = !selectedCoachName || String(item.coachName) === String(selectedCoachName);
      if (lessonMatch && coachMatch) {
        (item.availableSlots || []).forEach(slot => set.add(`${slot.startTime} - ${slot.endTime}`));
      }
    });
    const arr = Array.from(set);
    arr.sort((a,b) => a.split(' - ')[0].localeCompare(b.split(' - ')[0]));
    return arr.map(s => ({ value: s, label: s }));
  }, [data, selectedLessonId, selectedCoachName]);

  useEffect(() => {
    setSelectedSlot("");
  }, [periodo, selectedLessonId, selectedCoachName]);

  const rows = useMemo(() => {
    const out = [];
    (data || []).forEach(item => {
      const lessonName = item.lessonName;
      const coachName = item.coachName;
      const lessonId = item.lessonId;
      (item.availableSlots || []).forEach(slot => {
        out.push({
          lessonId,
          lessonName,
          coachName,
          date: item.date,
          day: giornoItaliano(item.date),
          slot: `${slot.startTime} - ${slot.endTime}`,
          startTime: slot.startTime,
          endTime: slot.endTime,
          isAvailable: !!slot.isAvailable,
          notes: slot.notes || '-',
          status: slot.status,
          bookingType: slot.bookingType || null,
          // Se presente, id prenotazione utente per azioni su slot non disponibile
          bookingUserLessonId: slot.bookingUserLessonId || null,
          courseTeamId: slot.courseTeamId || null,
          sportType: (lessons.find(l => l.value === lessonId)?.sportType) || null,
        });
      });
    });
    const filtered = out.filter(r => (
      (!selectedLessonId || String(r.lessonId) === String(selectedLessonId)) &&
      (!selectedCoachName || String(r.coachName) === String(selectedCoachName)) &&
      (!selectedSlot || (`${r.startTime} - ${r.endTime}`) === selectedSlot)
    ));
    filtered.sort((a,b) => {
      const byLesson = a.lessonName.localeCompare(b.lessonName);
      if (byLesson !== 0) return byLesson;
      const byCoach = (a.coachName || "").localeCompare(b.coachName || "");
      if (byCoach !== 0) return byCoach;
      const byDay = a.date.localeCompare(b.date);
      if (byDay !== 0) return byDay;
      return (a.startTime || "").localeCompare(b.startTime || "");
    });
    return filtered;
  }, [data, lessons, selectedLessonId, selectedCoachName, selectedSlot]);

  // Risolve l'id della prenotazione utente per uno slot specifico
  const resolveUserLessonId = async (row) => {
    // Se l'id è già disponibile nello slot, usalo
    if (row.bookingUserLessonId) return row.bookingUserLessonId;
    try {
      const api = new MyApiClient();
      const list = await api.getUserBookingLessons(token, row.lessonId);
      if (Array.isArray(list)) {
        const found = list.find(el => (
          el.bookingDate === row.date &&
          el.startTime === row.startTime &&
          el.endTime === row.endTime
        ));
        return found ? found.id : null;
      }
      return null;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  // Azioni: Visualizza
  const openDetail = async (row) => {
    // Slot di pianificazione team
    if (row.bookingType === 'TEAM_BOOKING') {
      if (row.courseTeamId) {
        // Il dettaglio della squadra di oggi (pages/struttura/corsi/squadraDettaglio)
        navigate('/struttura/corsi/squadre/' + row.courseTeamId);
      } else {
        navigate('/struttura/corsi/squadre');
      }
      return;
    }
    setLoadingShowed(true);
    const userLessonId = await resolveUserLessonId(row);
    setLoadingShowed(false);
    if (userLessonId) {
      navigate('/struttura/booking/userlessons/' + userLessonId);
    } else {
      setModalTitle("Errore durante l'operazione");
      setModalText("Impossibile aprire il dettaglio: prenotazione non trovata per lo slot selezionato.");
      setModalShowed(true);
    }
  };

  // Azioni: Annulla
  const deleteDetail = async (row) => {
    if (await chiediConferma({ titolo: 'Annullare la prenotazione?', testo: `La prenotazione della lezione${row.lessonName ? ` «${row.lessonName}»` : ''} viene annullata.`, conferma: 'Annulla prenotazione' })) continueDelete(row);
  };

  const continueDelete = async (row) => {
    setLoadingShowed(true);
    const userLessonId = await resolveUserLessonId(row);
    if (!userLessonId) {
      setLoadingShowed(false);
      setModalTitle("Errore durante l'operazione");
      setModalText("Prenotazione non trovata per lo slot selezionato.");
      setModalShowed(true);
      return;
    }
    try {
      const api = new MyApiClient();
      const resp = await api.setCancelledUserLesson(token, userLessonId, '');
      setLoadingShowed(false);
      if (!resp || resp.error) {
        setModalTitle("Errore durante l'operazione");
        setModalText(conMotivo("Si è verificato un errore durante l'annullamento."));
        setModalShowed(true);
      } else {
        // Ricarica calendario per riflettere lo stato
        fetchCalendar();
      }
    } catch (error) {
      setLoadingShowed(false);
      console.error(error);
      setModalTitle("Errore durante l'operazione");
      setModalText(conMotivo("Si è verificato un errore durante l'annullamento."));
      setModalShowed(true);
    }
  };

  // Azioni: Pagamento
  const paymentDetail = (row) => {
    setSelectedRow(row);
    setConfirmPaymentShowed(true);
  };

  const continuePayment = async (row, selectedPagamento) => {
    setConfirmPaymentShowed(false);
    setLoadingShowed(true);
    const userLessonId = await resolveUserLessonId(row);
    if (!userLessonId) {
      setLoadingShowed(false);
      setModalTitle("Errore durante l'operazione");
      setModalText("Prenotazione non trovata per lo slot selezionato.");
      setModalShowed(true);
      return;
    }
    try {
      const api = new MyApiClient();
      const resp = await api.setPayedUserLesson(token, userLessonId, selectedPagamento, skip_generate_document);
      setLoadingShowed(false);
      if (!resp || resp.error) {
        setModalTitle("Errore durante l'operazione");
        setModalText(conMotivo("Si è verificato un errore durante la registrazione del pagamento."));
        setModalShowed(true);
      } else {
        fetchCalendar();
      }
    } catch (error) {
      setLoadingShowed(false);
      console.error(error);
      setModalTitle("Errore durante l'operazione");
      setModalText(conMotivo("Si è verificato un errore durante la registrazione del pagamento."));
      setModalShowed(true);
    }
  };

  // Azioni: Rimborso
  const refundDetail = async (row) => {
    if (await chiediConferma({ titolo: 'Rimborsare la prenotazione?', testo: 'La lezione sarà impostata come rimborsata. Nessun documento verrà emesso.', conferma: 'Rimborsa', variante: 'primary' })) continueRefund(row);
  };

  const continueRefund = async (row) => {
    setLoadingShowed(true);
    const userLessonId = await resolveUserLessonId(row);
    if (!userLessonId) {
      setLoadingShowed(false);
      setModalTitle("Errore durante l'operazione");
      setModalText("Prenotazione non trovata per lo slot selezionato.");
      setModalShowed(true);
      return;
    }
    try {
      const api = new MyApiClient();
      const resp = await api.setRefundedUserLesson(token, userLessonId, '');
      setLoadingShowed(false);
      if (!resp || resp.error) {
        setModalTitle("Errore durante l'operazione");
        setModalText(conMotivo("Si è verificato un errore durante l'impostazione a rimborsato."));
        setModalShowed(true);
      } else {
        fetchCalendar();
      }
    } catch (error) {
      setLoadingShowed(false);
      console.error(error);
      setModalTitle("Errore durante l'operazione");
      setModalText(conMotivo("Si è verificato un errore durante l'impostazione a rimborsato."));
      setModalShowed(true);
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card">
          <div className="card-body sid-card-body--spaced">
            {/* Modale caricamento operazioni */}
            <Modal className="fade" show={loadingShowed} centered>
              <Modal.Body className="text-center">
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
                <div>Caricamento in corso...</div>
              </Modal.Body>
            </Modal>

            {/* Modale messaggi */}
            <Modal className="fade" show={modalShowed} centered>
              <Modal.Header>
                <Modal.Title>{modalTitle}</Modal.Title>
                <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                </Button>
              </Modal.Header>
              <Modal.Body>
                <Row><Col className="col-xl-64">{modalText}</Col></Row>
              </Modal.Body>
              <Modal.Footer className="justify-content-between">
                <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                  Chiudi
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Modale conferma pagamento */}
            <Modal className="fade" show={confirmPaymentShowed} centered>
              <Modal.Header>
                <Modal.Title>Registra pagamento</Modal.Title>
                <Button onClick={() => setConfirmPaymentShowed(false)} variant="" className="btn-close">
                </Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col className="col-xl-64">
                    La lezione sarà impostata come pagata. <b>Attenzione!</b> Procedendo il corrispondente documento fiscale verrà emesso e inviato se abilitato per la tua struttura.
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col className="col-xl-64">
                    <Form.Label htmlFor="modalita_pagamento">Modalità di pagamento *</Form.Label>
                    <Select
                      inputId="modalita_pagamento"
                      className="mt-2"
                      name="modalita_pagamento"
                      placeholder="Seleziona la modalità di pagamento"
                      value={optionsPayment.find(option => option.value === modalita_pagamento) || null}
                      onChange={(selectedOption) => handleSelectChange(selectedOption, "modalita_pagamento")}
                      options={optionsPayment}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col className="col-xl-64">
                    <Form.Label>Genera documento</Form.Label>
                    <Select
                      isDisabled={!isFatturazioneConfirmed}
                      className="mt-2"
                      name="skip_generate_document"
                      placeholder="Seleziona"
                      value={[{value: false, label: 'Si'}, {value: true, label: 'No'}].find(option => option.value === skip_generate_document) || null}
                      onChange={(selectedOption) => handleSelectChange(selectedOption, "skip_generate_document")}
                      options={[{value: false, label: 'Si'}, {value: true, label: 'No'}]}
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer className="justify-content-between">
                <Button className="btn btn-light btn-add" onClick={() => setConfirmPaymentShowed(false)}>
                  Annulla
                </Button>
                <Button
                  className="btn btn-primary btn-add"
                  onClick={() => {
                    if (!modalita_pagamento) {
                      segnalaMancanti([{ campo: 'modalita_pagamento', messaggio: 'Manca la modalità di pagamento' }]);
                      return;
                    }
                    setConfirmPaymentShowed(false);
                    continuePayment(selectedRow, modalita_pagamento);
                  }}
                >
                  Registra pagamento
                </Button>
              </Modal.Footer>
            </Modal>
            <Row className="justify-content-start">
              {!loadingLessons && lessons.length > 0 && (
                <Col xs="auto" className="mb-2">
                  <Form.Label>Lezione</Form.Label>
                  <Form.Select
                    value={selectedLessonId}
                    onChange={(e) => setSelectedLessonId(e.target.value)}
                    size="sm"
                    style={{ minWidth: 220, height: controlHeight }}
                  >
                    <option value="">Tutte</option>
                    {lessons.map(l => (
                      <option key={l.value} value={l.value}>{l.label}</option>
                    ))}
                  </Form.Select>
                </Col>
              )}
              {!loadingLessons && coaches.length > 0 && (
                <Col xs="auto" className="mb-2">
                  <Form.Label>Staff tecnico</Form.Label>
                  <Form.Select
                    value={selectedCoachName}
                    onChange={(e) => setSelectedCoachName(e.target.value)}
                    size="sm"
                    style={{ minWidth: 200, height: controlHeight }}
                  >
                    <option value="">Tutto</option>
                    {coaches.map(c => (
                      <option key={c.value} value={c.value}>{c.label}</option>
                    ))}
                  </Form.Select>
                </Col>
              )}
              <CampiPeriodo periodo={periodo} onCambia={setPeriodo} altezza={controlHeight} />
              <Col xs="auto" className="mb-2">
                <Form.Label>Slot</Form.Label>
                <Form.Select
                  value={selectedSlot}
                  onChange={(e) => setSelectedSlot(e.target.value)}
                  size="sm"
                  style={{ minWidth: 160, height: controlHeight }}
                >
                  <option value="">Tutti</option>
                  {slotOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col xs="auto" className="d-flex align-items-end mb-2">
                <button className="btn btn-primary btn-sm d-inline-flex align-items-center" onClick={fetchCalendar} disabled={loading} style={{ height: controlHeight }}>
                  {loading ? <Spinner size="sm" animation="border" className="me-2" /> : null}
                  Cerca
                </button>
              </Col>
            </Row>

            <div className="table-responsive">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Lezione</th>
                    <th>Staff tecnico</th>
                    <th>Giorno</th>
                    <th>Slot</th>
                    <th>Stato</th>
                    <th>Dettagli</th>
                    <th>Pagamento</th>
                    <th>Azione</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <Spinner animation="border" />
                      </td>
                    </tr>
                  )}
                  {!loading && rows.length === 0 && (
                    <tr>
                      <td colSpan="8" className="text-center text-muted">
                        Nessun dato disponibile
                      </td>
                    </tr>
                  )}
                  {!loading && rows.map((row, idx) => {
                    const prev = rows[idx - 1];
                    const sameGroup = prev && prev.lessonName === row.lessonName && prev.coachName === row.coachName && prev.day === row.day;
                    const lessonCell = sameGroup ? "" : row.lessonName;
                    const coachCell = sameGroup ? "" : row.coachName;
                    const dayCell = sameGroup ? "" : row.day;
                    return (
                      <tr key={`${row.lessonId}-${idx}`}>
                        <td>{lessonCell}</td>
                        <td>{coachCell}</td>
                        <td>{dayCell}</td>
                        <td>{row.slot}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <i className={`fa fa-circle me-1 ${row.isAvailable ? 'text-success' : 'text-danger'}`}></i>
                            <span className="text-dark">{row.isAvailable ? 'Disponibile' : 'Prenotato'}</span>
                          </div>
                        </td>
                        <td>{row.notes.replace(/^Slot automatico per /i, '').replace(/^./, c => c.toUpperCase())}</td>
                        <td>
                          {!row.isAvailable && row.bookingType !== 'TEAM_BOOKING' ? (
                            <div className="d-flex align-items-center">
                              <i className={`fa fa-circle me-1 ${row.status === 'PAID' ? 'text-success' : 'text-danger'}`}></i>
                              <span className="text-dark">{row.status === 'PAID' ? 'Pagato' : 'Non pagato'}</span>
                            </div>
                          ) : null}
                        </td>
                        <td>
                          <Dropdown drop="auto">
                            <Dropdown.Toggle className="btn-primary light sharp i-false btn-action">
                              <More />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {row.isAvailable ? (
                                <Dropdown.Item onClick={() => openBookingModal(row)}>
                                  <span className="me-2"><User size="20" /></span> Prenota
                                </Dropdown.Item>
                              ) : (
                                <>
                                  <Dropdown.Item onClick={() => openDetail(row)}><span className="me-2"><User size="20" /></span> {row.bookingType === 'TEAM_BOOKING' ? 'Vai al team' : 'Visualizza'}</Dropdown.Item>
                                  {row.bookingType !== 'TEAM_BOOKING' && row.status === 'UNPAID' && <Dropdown.Item onClick={() => paymentDetail(row)} className="text-danger"><span className="me-2"><MoneyRecive size="20"/></span>Registra pagamento</Dropdown.Item> }
                                  {row.bookingType !== 'TEAM_BOOKING' && row.status === 'UNPAID' && <Dropdown.Item onClick={() => deleteDetail(row)} className="text-danger"><span className="me-2"><Trash size="20"/></span>Annulla</Dropdown.Item> }
                                  {row.bookingType !== 'TEAM_BOOKING' && row.status === 'PAID' && <Dropdown.Item onClick={() => refundDetail(row)} className="text-danger"><span className="me-2"><MoneySend size="20"/></span>Rimborsa</Dropdown.Item> }
                                </>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Modal className="fade" show={bookingPlayerModal} centered onHide={() => setBookingPlayerModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Seleziona player</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {pendingBookingSlot && (
            <p className="text-muted mb-3">
              Slot: <strong>{pendingBookingSlot.day}, {pendingBookingSlot.startTime} – {pendingBookingSlot.endTime}</strong>
            </p>
          )}
          <Form.Label htmlFor="prenota-player">Player *</Form.Label>
          <AsyncSelect
            inputId="prenota-player"
            value={selectedBookingPlayer}
            onChange={setSelectedBookingPlayer}
            loadOptions={loadBookingPlayerOptions}
            placeholder="Digita almeno 3 caratteri..."
            noOptionsMessage={({ inputValue }) =>
              inputValue.length < 3 ? "Digita almeno 3 caratteri" : "Nessun utente trovato"
            }
            loadingMessage={() => "Ricerca in corso..."}
            isClearable
            cacheOptions
            defaultOptions={false}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setBookingPlayerModal(false)}>Annulla</Button>
          <Button variant="primary" onClick={confirmBooking}>Conferma</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LessonsCalendar;